import React, { useEffect, useState } from "react";
import { URL } from "../Redux/common/url";

const FaqSection = () => {
  const [productLists, setProductLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(0); // ✅ moved here

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/workListPublic`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setProductLists(data?.works || []);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="text-center py-5">Loading...</p>;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ backgroundColor: "#eaf2f7" }} className="py-5 container-fluid px-0">
      <div className="container-fluid my-2">
        <div className="row ">
          {/* Heading */}
          <div className="col-md-6">
            {/* <p className="text-danger fw-bold small mb-1">FAQ ---------</p> */}
            <h1 className="fw-bold mb-4" style={{ color: '#079000'}}>Frequently Asked Questions</h1>
            <div>
              <img
                src="https://img.freepik.com/premium-vector/faq-banner-concept-questionnaire-giving-information-users-website-customers-with-cartoon-people-vector-illustration-isolated-white-background_181313-1312.jpg"
                alt="FAQ Banner"
                className="faq-banner"
              />
            </div>
          </div>

          {/* Accordion */}
          <div className="accordion col-md-6" id="faqAccordion">
            {productLists && productLists.length > 0 ? (
              productLists.map((item, index) => (
                <div
                  className="accordion-item mb-3 border-0 shadow-sm rounded"
                  key={index}
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button fw-semibold ${
                        openIndex === index ? " " : "bg-white"
                      }`}
                      type="button"
                      onClick={() => toggleFAQ(index)}
                      style={{ background: openIndex === index ? '#079000': 'white', color: openIndex === index ? 'white' : '#079000' }}
                    >
                      <i
                        className={`me-2 fas ${
                          openIndex === index
                            ? "fa-circle-chevron-up"
                            : "fa-circle-chevron-down"
                        }`}
                      ></i>
                      {item.title}
                    </button>
                  </h2>
                  {openIndex === index && (
                    <div className="accordion-body text-muted ">
                      {item.short_description}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p>No FAQs found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
